





















import { QuestionTypes } from "../../enums/questiontypes";
import TextQuestion from "./TextQuestion.vue";
import CheckboxYesOrNo from "./CheckboxYesOrNo.vue";
import CheckboxYesOrNoGroup from "./CheckboxYesOrNoGroup.vue";
import Vue, { Component } from "vue";

const component: Component = Vue.extend({
  name: "QuestionInput",
  components: {
    TextQuestion,
    CheckboxYesOrNo,
    CheckboxYesOrNoGroup
  },
  data() {
    return {
      types: QuestionTypes,
      result: this.value
    };
  },
  props: ["value", "type", "rules"],
  methods: {
    updateVal(): void {
      this.$emit("input", this.result);
    }
  }
});
export default component;
